import React from 'react'
import { Action } from 'redux';
import {
    GET_DROPDOWN_REQUEST,
    GET_DROPDOWN_SUCCESS,
    GET_DROPDOWN_ERROR,
    DropdownType,
    DropdownDispatchTypes
} from '../constants//RestaurantDropdownActionType'


interface DefaultState {
    loading: boolean,
    dropdownList?: DropdownType,
}


const initialState: DefaultState = {
    loading: false,
}


const DropdownReducer = (state: DefaultState = initialState, action: DropdownDispatchTypes): DefaultState => {
    switch (action.type) {
        case GET_DROPDOWN_REQUEST:
            return {
                // ...state,
                loading: true
            }

        case GET_DROPDOWN_SUCCESS:
            return {
                // ...state,
                loading: false,
                dropdownList: action.payload,

            }

        case GET_DROPDOWN_ERROR:
            return {
                // ...state,
                loading: false,
                // error: action.payload
            }

        default:
            return state
            break;
    }
}

export default DropdownReducer